import * as React from "react";
import {observer, inject} from "mobx-react";

import { AppStore, EAIError } from "Stores/appStore";
import { Button, Modal } from "react-bootstrap";
import {useAppContext} from "@/contexts/app";

@inject("appStore")
@observer
export class Errors extends React.Component<{ appStore?: AppStore }, any> {

    handleClose () {
        if ( !this.props.appStore ) return;

        if (this.props.appStore.callbackOnError) {
            this.props.appStore.callbackOnError();
        }
        this.props.appStore.clearErrors();
    }


    render() {
        if ( !this.props.appStore ) return null;
        return (
            <Modal show={this.props.appStore.shouldDisplayErrors} centered={true} dialogClassName="modal-errors">
                <Modal.Body className="text-center">
                    <div className="error-icon"><i className="icon icon-exclamation-circle" /></div>
                    <div className="content">
                        <ul>
                            { this.props.appStore.globalErrors.map((err: EAIError, idx: number) => (<li key={idx}> { err.repeats ? "["+err.repeats+"] " : ""}{err.message}</li>)) }
                        </ul>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="alert-action">
                    <Button size="lg" variant="primary" onClick={() => this.handleClose() } style={{float: "right"}}>
                        Close
                    </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export function ErrorsAppContext() {
    const {errors, clearErrors} = useAppContext();

    const handleClose = () => {
        if (errors.length === 0) {
            return;
        }
        clearErrors();
    };

    return (
        <Modal show={errors.length > 0} centered={true} dialogClassName="modal-errors">
            <Modal.Body className="text-center">
                <div className="error-icon"><i className="icon icon-exclamation-circle" /></div>
                <div className="content">
                    <ul>
                        { errors.map((err, idx: number) => (<li key={idx}> { err.repeats ? "["+err.repeats+"] " : ""}{err.message}</li>)) }
                    </ul>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="alert-action">
                    <Button size="lg" variant="primary" onClick={() => handleClose() } style={{float: "right"}}>
                        Close
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
